import React, { FC } from 'react';
import styled from '@emotion/native';

import * as WebBrowser from 'expo-web-browser';
import ExternalLinkIcon from '@assets/icons/external-link';
import { Button, ButtonProps } from '@components/2-molecules/Buttons';

const Container = styled(Button)``;


type Props = ButtonProps & {
    uri: string;
};


const Link: FC<Props> = ({ uri, ...props }) => {

    const _onPress = () => WebBrowser.openBrowserAsync(uri);

    return (
        <Container
            small
            color='#000'
            fullwidth={false}
            outlined
            right={<ExternalLinkIcon />}
            onPress={_onPress}
            {...props} />
    );
};

export default Link;